import PropTypes from 'prop-types';
import { RentalStatus } from 'models/enums';
import { RENTAL_STATUS_TEXT } from 'strings/rental-status';
import {
  validFutureOrTodayMMDDYYDate,
  validFutureOrTodayMMYYDate,
} from 'utils/validation';
import FormLayout from 'layouts/FormLayout/FormLayout';
import { MoveOutOptionsFields } from '../MoveOutOptionsFields/MoveOutOptionsFields';
import { MoveOutSpecificDateFields } from '../MoveOutSpecificDateFields/MoveOutSpecificDateFields';
import { MoveOutDateRangeFields } from '../MoveOutDateRangeFields/MoveOutDateRangeFields';
import { MoveOutResidentsFoundFields } from '../MoveOutResidentsFoundFields/MoveOutResidentsFoundFields';
import { MoveOutNotSureFields } from '../MoveOutNotSureFields/MoveOutNotSureFields';

export const FamilyOccupiedMoveOutSection = ({ name }) => (
  <FormLayout.Section sectionTitle={RENTAL_STATUS_TEXT.familyOccupiedMoveout}>
    <MoveOutOptionsFields name={name} />
    <MoveOutSpecificDateFields
      extraValidation={validFutureOrTodayMMDDYYDate}
      name={name}
    />
    <MoveOutDateRangeFields
      extraValidation={validFutureOrTodayMMYYDate}
      name={name}
    />
    <MoveOutResidentsFoundFields
      name={name}
      rentalStatus={RentalStatus.FamilyOccupied}
    />
    <MoveOutNotSureFields name={name} />
  </FormLayout.Section>
);

FamilyOccupiedMoveOutSection.propTypes = {
  name: PropTypes.string.isRequired,
};
